import { Service } from "../Service";
import { IWebApiClient } from "./IWebApiClient";
import { NAMESPACE } from "./_Namespace";

export class WebApiClientService extends Service<IWebApiClient>
{
    public static override classNamespace = NAMESPACE + "WebApiClientService";
    public static override className = "WebApiClientService";
}